module.exports = __webpack_public_path__ + "static/media/VAR-NEW.794ec461.apng";